// Global
import Vue                  from 'vue/dist/vue.min.js';
import VueResource          from 'vue-resource'
import VueRouter            from 'vue-router'
import store                from '../store'
import App                  from '../App.vue'
import Meta                 from 'vue-meta'
Vue.use(Meta)

// Builder Component
import BuildHome            from '../components/builder/BuildHome.vue'
import Builder              from '../components/builder/Builder.vue'
import CPU                  from '../components/builder/CPU'
import Compare              from '../components/builder/Compare.vue'
import Cart                 from '../components/builder/Cart.vue'

// Desktop
import Desktops             from '../Desktops.vue'

// User Profile
import ItemsController      from '../components/admin/ItemsController'
import Dashboard            from '../components/admin/Dashboard.vue'
import Register             from '../components/admin/Register.vue'
import RegisterSuccess      from '../components/admin/RegisterSuccess.vue'
import Profile              from '../components/admin/Profile.vue'
import MyBuild              from '../components/admin/MyBuild.vue'
import YourOrders           from '../components/admin/YourOrders.vue'
import Items                from '../components/admin/Items.vue'
import AddPart              from '../components/admin/AddPart.vue'
import AppHome              from '../components/AppHome.vue'

// Project
import Project              from '../components/project/pages/Project.vue'


const builderUrl = '/builder/'

Vue.use(VueRouter)
Vue.use(VueResource)

export const routes = [{

    // Builder
        path: "/",
        redirect: "/builder",
        name: "App",
        components: {
            default: App
        },
        children: [
            {
                name: 'AppHome',
                path: 'app',
                component: AppHome,
            },
            {
                path: 'builder',
                component: Builder,
                redirect: to => {
                    // the function receives the target route as the argument
                    return store.getters.lastRoute
                },
                children: [{
                        path: builderUrl + "home",
                        name: 'Home',
                        component: BuildHome,
                    },
                    {
                        path: builderUrl + 'cpu',
                        name: 'cpu',
                        component: CPU,
                    },
                    {
                        path: builderUrl + 'motherboard',
                        name: 'motherboard',
                        component: CPU,
                    },
                    {
                        path: builderUrl + 'ram',
                        name: 'ram',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'storage',
                        name: 'storage',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'gpu',
                        name: 'gpu',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'psu',
                        name: 'psu',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'case',
                        name: 'case',
                        component: CPU
                    },
                    {
                        path: builderUrl + 'accessories',
                        name: 'accessories',
                        component: CPU
                    },
                ]
            },
            {
                path: builderUrl + "compare",
                name: "Compare",
                component: Compare,
            },
            {
                path: builderUrl + "cart",
                name: "Cart",
                component: Cart,
            }
        ]
    },
    // Docs
    {
        path: '/docs',
        name: "Documentation",
        component: Compare,
    },
    // Desktops
    {
        path: "/desktops",
        name: "Desktops",
        component: Desktops,
    },

    // User Profile
    {
        path: "/users/success",
        name: "RegisterSuccess",
        component: RegisterSuccess,
    },
    {
        path: "/users/register",
        name: "Register",
        component: Register,
    },
    {
        path: "/users/login",
        name: "Login",
        component: Register,
    },
    // {
    //     path: "/users/resetpassword",
    //     name: "Reset Password",
    //     component: ResetPassword,
    // },

    // User Dashboard
    {
        path: "/users/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            requiresAuth: true
        },
        redirect: '/users/profile',
        children: [
            {
                path: "/users/items-controller",
                name: "ItemsController",
                component: ItemsController,
                children: [
                    {
                        path: "/users/items-controller/items",
                        name: "Items",
                        component: Items,
                    },
                    {
                        path: "/users/items-controller/addpart",
                        name: "Add Part",
                        component: AddPart,
                    },
                    {
                        path: "/users/items-controller/editpart",
                        name: "Edit Part",
                        component: AddPart,
                    },
                ]
            },
            {
                path: "/users/profile",
                name: "Profile",
                component: Profile,
            },
            {
                path: "/users/mybuild",
                name: "My Build",
                component: MyBuild,
            },
            {
                path: "/users/orders",
                name: "Your Orders",
                component: YourOrders,
            },
        ]

    },

    //Project
    {
        path: "/project",
        name: "Project",
        component: Project,
    },
];

export const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'is-active',
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
          return {
            selector: to.hash,
            behavior: 'smooth',
          }
        }
      }
})
router.beforeEach(async(to, from, next) => {
    console.log('Router beforeEach Started')

    // checking protected routes
    if (to.matched.some(record => record.meta.requiresAuth)) {
        console.log('The Route Is Protected')
        // this route requires auth, check if user is logged in
        // if not, redirect to login page.
        if (!localStorage.usertoken) {
            await store.dispatch('setLoggedOut')
            console.log('missing localstorage.usertoken, redirecting to /login')
            await store.dispatch('setLoggedIn', false)
            next({
                path: '/users/login',
                query: { redirect: to.fullPath }
            })
        } else {
            console.log('token found')
            // check if the token is still valid
            try {
                console.log('checking token validation....')
                console.log(localStorage.usertoken)
                await store.dispatch('validate')
                await store.dispatch('setLoggedIn')
                console.log('valid token')
                    // user is logged in with a valid token
                next()
            } catch (e) {
                await store.dispatch('setLoggedOut')
                console.log('token is invalid, deleting token from state')
                    // the token is invalid so we will have the user login again
                    // clear the token and user info
                    // store.commit('DELETE_USER')
                    // console.log('user deleted, redirecting to /corp/login')
                next({
                    path: '/',
                    query: { redirect: to.fullPath }
                })
            }
        }
    } 
    else {
        if(store.getters.loggedIn == 'true' && store.getters.getUser == null){
            await store.dispatch('validate')
        }
    console.log('the route is not protected')
    next()
    }
})